import React, { memo, useState, useEffect } from "react";
import { Stack } from "investira.react.components";
import { BaseTemplate } from "../../components/templates";
import { useSelector } from "react-redux";
import { SearchAtivosAdd } from "../../components/organisms";
import AtivosBlacklist from "../BlacklistFundos/AtivosBlacklist";
import services from "../../services";
import withResponseHandling from "../../hoc/withResponseHandling";

const CustodianteAtivosIgnorados = memo(() => {
  const { default_entidade_id } = useSelector(
    (store) => store.entidade.current,
  );

  const [conferenciasCustodiantes, setConferenciasCustodiantes] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  function handleClick(pIfeedAtivoId) {
    services.conferenciasCustodiantes.ignoradasAdd(
      {
        entidade_id: default_entidade_id,
        ifeed_ativo_id: pIfeedAtivoId,
      },
      () => {
        services.conferenciasCustodiantes.ignoradasList(
          { sort: "ativo_id" },
          (rRes) => {
            setConferenciasCustodiantes(rRes.data);
          },
        );
      },
      (rErr) => {},
    );
  }

  function handleDelete(pIfeedAtivoId) {
    services.conferenciasCustodiantes.ignoradasRemove(
      {
        entidade_id: default_entidade_id,
        ativo_id: pIfeedAtivoId,
      },
      () => {
        services.conferenciasCustodiantes.ignoradasList(
          { sort: "ativo_id" },
          (rRes) => {
            setConferenciasCustodiantes(rRes.data);
          },
        );
      },
      (rErr) => {},
    );
  }

  useEffect(() => {
    setIsLoading(true);
    services.conferenciasCustodiantes.ignoradasList(
      { sort: "ativo_id" },
      (rRes) => {
        setConferenciasCustodiantes(rRes.data);
      },
      (rErr) => {},
      () => {
        setIsLoading(false);
      },
    );
  }, [default_entidade_id]);

  return (
    <BaseTemplate
      title="Ativos Ignorados Conferência Custodiante"
      maxWidth="lg"
    >
      <Stack spacing={4}>
        <SearchAtivosAdd onClick={handleClick} pageIsLoading={isLoading} />
        <AtivosBlacklist
          posicoes={conferenciasCustodiantes}
          onDelete={handleDelete}
          isLoading={isLoading}
        />
      </Stack>
    </BaseTemplate>
  );
});

export default withResponseHandling(CustodianteAtivosIgnorados);
